import React, { FunctionComponent } from 'react';
import ChromeDesktop from './chromeDesktop/ChromeDesktop';
import SafariDesktop from './safariDesktop/SafariDesktop';
import ChromeMobile from './chromeMobile/ChromeMobile';
import SafariMobile from './safariMobile/SafariMobile';
import chromeQuickLocation from 'assets/images/help/chrome-quick-location-enabling.png';
import Styles from './BrowserSettings.module.scss';

const BrowserSettings: FunctionComponent = () => {
  return (
    <div className={Styles.browserSettingsWrapper}>
      <div className={Styles.header}>
        <h2 className="fontTwentyFour poppins-bold text-black mb-20">
          Step 1: Enable Location in Browser
        </h2>
        <p className="fontSixteen poppins-regular text-gray mb-20">
          First, make sure your browser can access your location. Choose your browser and device type below.
        </p>
        
        <div className={Styles.quickTip}>
          <h3 className="fontEighteen poppins-bold text-black mb-15">
            💡 Quick Tip for Chrome Users
          </h3>
          <p className="fontFourteen poppins-regular text-gray mb-15">
            You can quickly enable/disable location access by clicking the site settings icon in the address bar. 
            This icon appears when a website requests your location.
          </p>
          <img 
            src={chromeQuickLocation} 
            alt="Chrome address bar showing site settings popup for quick location enabling" 
            className={Styles.quickTipImage}
          />
          <p className={Styles.imageCaption}>
            Click the site settings icon in Chrome's address bar for quick access
          </p>
        </div>
      </div>

      <div className={Styles.browserList}>
        <div className={Styles.browserSection}>
          <div className={Styles.browserHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">Chrome (Desktop)</h3>
            <p className="fontFourteen poppins-regular text-gray">Windows, Mac, Linux</p>
          </div>
          <ChromeDesktop />
        </div>

        <div className={Styles.browserSection}>
          <div className={Styles.browserHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">Safari (Desktop)</h3>
            <p className="fontFourteen poppins-regular text-gray">Mac only</p>
          </div>
          <SafariDesktop />
        </div>

        <div className={Styles.browserSection}>
          <div className={Styles.browserHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">Chrome (Mobile)</h3>
            <p className="fontFourteen poppins-regular text-gray">Android devices</p>
          </div>
          <ChromeMobile />
        </div>

        <div className={Styles.browserSection}>
          <div className={Styles.browserHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">Safari (Mobile)</h3>
            <p className="fontFourteen poppins-regular text-gray">iPhone, iPad</p>
          </div>
          <SafariMobile />
        </div>
      </div>
    </div>
  );
};

export default BrowserSettings;